<script setup lang="ts">
import type { DogtagComponentType } from '@/types/gloss';

import { getColor } from '../lib';
import type { Size, DogTagComponent } from '../model/types';
import { SymbolMap as imageClantagMap } from '../model';

const DEFAULT_X = '50%';
const DEFAULT_Y = '90%';
const DEFAULT_BG_COLOR = '#ffffff';

const { clanTag, components, size } = defineProps<{
  clanTag: string | null;
  components: Record<DogtagComponentType, DogTagComponent>;
  size?: Size;
}>();

const symbolsSpriteImg = await import('./images/symbols/symbolsMedium.webp');
const imgUrl = `url(${symbolsSpriteImg.default})`;

const { patch: patchComponent, background: bgComponent } = components;

const SYMBOLS = clanTag ? [...clanTag] : ['placeholder'];

const x = bgComponent.clanTag?.x || patchComponent.clanTag?.x;
const y = bgComponent.clanTag?.y || patchComponent.clanTag?.y;
const clantagStyle = {
  left: x ? `${x}%` : DEFAULT_X,
  top: y ? `${y}%` : DEFAULT_Y,
};

const COLOR: string =
  bgComponent.clanTag?.fontColor ||
  patchComponent.clanTag?.fontColor ||
  getColor(components.border_color?.color || '') ||
  DEFAULT_BG_COLOR;
</script>

<template>
  <span
    v-if="symbolsSpriteImg.default"
    :class="['clantag', { sm: size === 'SM' }]"
    :style="clantagStyle"
  >
    <span
      v-for="(symbol, index) in SYMBOLS"
      :key="index"
      class="symbol"
      :style="{
        width: imageClantagMap[symbol as keyof typeof imageClantagMap].w + 'px',
        height: imageClantagMap[symbol as keyof typeof imageClantagMap].h + 'px',
        maskPosition: `-${imageClantagMap[symbol as keyof typeof imageClantagMap].x}px -${imageClantagMap[symbol as keyof typeof imageClantagMap].y}px`,
        backgroundPosition: `-${imageClantagMap[symbol as keyof typeof imageClantagMap].x}px -${imageClantagMap[symbol as keyof typeof imageClantagMap].y}px`,
      }"
    />
  </span>
</template>

<style scoped lang="postcss">
.clantag {
  position: absolute;
  transform: translate(-50%, -50%);
  display: flex;

  &.SM {
    transform: translate(-50%, -50%) scale(0.3);
  }

  .symbol {
    display: inline-block;

    background:
      v-bind(imgUrl) 0 0 no-repeat,
      v-bind(COLOR);
    background-blend-mode: overlay;

    mask-image: v-bind(imgUrl);
    mask-repeat: no-repeat;
  }
}
</style>
